import type { analytics as en } from "../en/analytics";
import type { Messages } from "../types";

export const analytics: Messages<typeof en> = {
  openDashboard: "فتح كلوحة متابعة",
  allDashboards: "كل لوحات المتابعة",
  allHint: "كل حساباتك معاً. اختر حساباً لترى أرقامه وحده.",
  noAccounts: "اربط إنستغرام لترى التحليلات",
  noAccountsHint: "تظهر هنا مرات الوصول والمشاهدات وأفضل أوقات النشر وجمهورك بعد ربط حساب.",
  connect: "اربط إنستغرام",
  title: "التحليلات",
  description: "أداء محتواك ومن هو جمهورك.",
  account: "الحساب",
  range: "الفترة",
  ranges: {
    d7: "7 أيام",
    d28: "28 يوماً",
    d90: "90 يوماً",
  },
  metricTabs: "المقياس",
  current: "هذه الفترة",
  previous: "الفترة السابقة",
  noPrevious: "لا توجد فترة سابقة بعد",
  totalIn: "الإجمالي خلال {{range}}",
  change: "التغيّر",
  interactions: {
    title: "تفاصيل التفاعل",
    description: "ماذا فعل الناس مع محتواك",
  },
  bestTimes: {
    title: "أفضل وقت للنشر",
    description: "نشاط المتابعين حسب اليوم والساعة ({{tz}})",
    suggestions: "مواعيد مقترحة",
    activity: "النشاط {{score}}/100",
    compose: "جدولة منشور في هذا الوقت",
  },
  demographics: {
    title: "الجمهور",
    description: "أين يتواجد متابعوك ومن هم",
    countries: "أبرز الدول",
    cities: "أبرز المدن",
    age: "العمر",
    gender: "الجنس",
    female: "نساء",
    male: "رجال",
    unknown: "غير محدد",
    empty: "عدد المتابعين غير كافٍ بعد: يعرض إنستغرام بيانات الجمهور من 100 متابع.",
  },
  topPosts: {
    title: "أفضل المنشورات",
    description: "مرتبة حسب الوصول في هذه الفترة",
    empty: "لا توجد منشورات في هذه الفترة",
    reach: "الوصول",
    views: "المشاهدات",
    likes: "الإعجابات",
    saves: "الحفظ",
    open: "فتح المنشور",
  },
  sentiment: {
    see: "التعليقات: {{sentiment}}",
    title: "المشاعر عبر الوقت",
    description: "التعليقات حسب المشاعر، أسبوعياً",
    week: "أسبوع {{date}}",
    empty: "لا توجد تعليقات بعد",
  },
  export: "تصدير CSV",
  exported: "تم تنزيل ملف CSV",
  allAccountsNote: "يتم عرض كل الحسابات مجتمعة.",
  table: "عرض كجدول",
  hideTable: "إخفاء الجدول",
  date: "التاريخ",
  error: "تعذّر تحميل التحليلات",
};
